import React, { Component } from 'react';
import '../App.css';
import RenderPixels from './RenderPixels';

const emptyCell=' ';
const fullCell='\u25A0';
const upperX=65;
const upperY=400;
//let Speed=200;

class Engine extends Component {
  constructor(props){
    super(props);
    let pixels=new Array(upperX);
    this.state={
      pixels: pixels,
      speed: 200
    }
    this.initiatePopulation=this.initiatePopulation.bind(this);
    this.initiateGame=this.initiateGame.bind(this);
    //this.changeSpeed=this.changeSpeed.bind(this);
  }

  initiatePopulation(){
    let pixels=new Array(upperX);
      for(let i=0; i<upperX; i++){
        let pixelRow=new Array(upperY);
        for(let j=0; j<upperY; j++){
          pixelRow[j]=emptyCell;
        }
          pixels[i]=pixelRow;
      }
      let numPixels=Math.floor(Math.random()*(upperX*upperY-1)+1);
      for(let i=0;i<numPixels;i++){
        let x=Math.floor(Math.random()*(upperX-2)+1);
        let y=Math.floor(Math.random()*(upperY-2)+1);
        pixels[x][y]=fullCell;
      }
      this.setState((prevState)=>({
        pixels: pixels
      }))
    setInterval(this.initiateGame,this.state.speed);
  }

  componentDidMount(){
    console.log("Engine Mounted");
    this.initiatePopulation();
  }


  initiateGame(){
      //console.log("Initiating Game");
      let pixels=this.state.pixels;
      let newPixels=new Array(upperX);

      for(let i=0; i<upperX; i++){
        let pixelRow=new Array(upperY);
        for(let j=0; j<upperY; j++){
          let k = pixels[i][j];
          pixelRow[j]=k;
        }
          newPixels[i]=pixelRow;
      }

      for(let i=1;i<upperX-1;i++){
        for(let j=1;j<upperY-1;j++){
          let count=0;
          if(pixels[i-1][j-1]===fullCell)count++;
          if(pixels[i-1][j]===fullCell)count++;
          if(pixels[i-1][j+1]===fullCell)count++;
          if(pixels[i][j-1]===fullCell)count++;
          if(pixels[i][j+1]===fullCell)count++;
          if(pixels[i+1][j-1]===fullCell)count++;
          if(pixels[i+1][j]===fullCell)count++;
          if(pixels[i+1][j+1]===fullCell)count++;

          if(pixels[i][j]===fullCell){
              if(count<2 || count>3)
                newPixels[i][j]=emptyCell;
          }
          else if(pixels[i][j]===emptyCell){
            if(count===3)
              newPixels[i][j]=fullCell;
          }
          count=0;
        }
      }

      this.setState((prevState)=>({
        pixels: newPixels
      }))
  }

  // changeSpeed=(speed)=>{
  //   this.setState((prevState)=>({
  //     speed: speed
  //   }))
  // }

  render() {
    return (
      <div className="App">
        <button className="selectButton"onClick={this.initiatePopulation}>Initiate new epoch</button>
        {
          /*
          <button className="selectButton"onClick={()=>this.changeSpeed(600)}>200ms</button>
          <button className="selectButton"onClick={()=>this.changeSpeed(50)}>100ms</button>
          */
        }
        <div className="Pixels">
          <RenderPixels pixels={this.state.pixels} />
        </div>
      </div>
    );
  }
}

export default Engine;



// WEBPACK FOOTER //
// ./src/Components/Engine.js